import type { ElementType } from 'react';
import { Flex, Icon, Text } from 'pixelize-design-library';

import { useAppTheme } from '@core/Theme/useAppTheme';

import { toneColors, type UiTone } from './tone';

export interface StatusTagProps {
  tone: UiTone;
  label: string;
  icon?: ElementType;
  testId?: string;
}

export function StatusTag({ tone, label, icon, testId }: StatusTagProps) {
  const { colors } = useAppTheme();
  const { ink, tint, edge } = toneColors(colors, tone);
  return (
    <Flex
      as='span'
      display='inline-flex'
      align='center'
      gap={1}
      h='22px'
      px={2}
      borderRadius='full'
      borderWidth='1px'
      borderColor={edge}
      bg={tint}
      color={ink}
      whiteSpace='nowrap'
      data-tone={tone}
      data-testid={testId}
    >
      {icon && <Icon as={icon} boxSize='12px' aria-hidden />}
      <Text as='span' fontSize='xs' fontWeight={600} lineHeight={1}>
        {label}
      </Text>
    </Flex>
  );
}
